import React, { Component } from 'react';

class IconPhone extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"><path className="a" d="M27.2,19.786l-6.125-2.625a1.313,1.313,0,0,0-1.531.377l-2.713,3.314a20.271,20.271,0,0,1-9.69-9.69L10.456,8.45a1.309,1.309,0,0,0,.377-1.531L8.209.794A1.321,1.321,0,0,0,6.7.033L1.017,1.346A1.313,1.313,0,0,0,0,2.625,25.373,25.373,0,0,0,25.375,28a1.313,1.313,0,0,0,1.28-1.017L27.968,21.3a1.328,1.328,0,0,0-.766-1.509Z" transform="translate(0 0)" fill="#ccc" /></svg>
        );
    }
}

export default IconPhone;